/**
 * The course editor is not offered on a phone (15 Oct 2026). Every way into it — a course tile,
 * Edit, a notification, a pasted link — goes through /editor/:id, so the guard sits on the route:
 * on a phone it opens the course's own page instead (which takes any language version's id), and
 * that page explains editing needs a computer.
 */
import { useState, type ReactNode } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { isPhone } from '@/lib/useIsPhone'

export function EditorGate({ children }: { children: ReactNode }) {
  const { id = '' } = useParams()
  // Decided once, when the editor is opened — not followed live. Snapping a laptop window to half
  // the screen crosses the phone width, and following it would throw the creator out mid-edit and
  // drop the last 1.5 s of unsaved changes (code review, 16 Oct 2026).
  // A TOUCH phone: a narrow desktop window (split screen, 200% zoom) still gets the editor.
  const [phone] = useState(() => isPhone() && typeof window !== 'undefined' && !!window.matchMedia?.('(pointer: coarse)').matches)
  if (phone) return <Navigate to={`/courses/${id}`} replace state={{ editorOnComputer: true }} />
  return <>{children}</>
}
